import React, { useState } from "react";
import styled from "styled-components";
import ContactModal from "./ContactModal";

const Wrapper = styled.section`
  padding: 80px 20px;
  display: flex;
  justify-content: center;

  /* 🔥 DARK BACKGROUND FOR CONTAINER */
  background: ${(p) =>
    p.theme.gradients?.bgSection ||
    `linear-gradient(180deg, ${p.theme.colors.bgDarker}, ${p.theme.colors.bgDark})`};

  position: relative;
  overflow: hidden;

  /* Soft glowing accent blur */
  &::before {
    content: "";
    position: absolute;
    width: 420px;
    height: 420px;
    border-radius: 50%;
    background: ${(p) => p.theme.gradients.accent};
    filter: blur(90px);
    opacity: 0.08;
    top: -100px;
    right: -80px;
    pointer-events: none;
  }
`;

const Banner = styled.div`
  width: 100%;
  max-width: 900px;

  padding: 40px 32px;
  border-radius: 18px;
  text-align: center;

  background: ${(p) =>
    p.theme.gradients?.primary ||
    `linear-gradient(90deg, ${p.theme.colors.primary}, ${p.theme.colors.primaryDark})`};

  color: ${(p) => p.theme.colors.bgDark};
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);

  @media (min-width: 720px) {
    padding: 50px 40px;
  }
`;

const Title = styled.h2`
  font-size: 1.9rem;
  font-weight: 900;
  margin: 0 0 10px 0;
  letter-spacing: -0.5px;

  color: ${(p) => p.theme.colors.bgDarker};
`;

const Subtitle = styled.p`
  margin: 0 auto;
  max-width: 780px;
  color: ${(p) => p.theme.colors.bgDarker};
  opacity: 0.85;
  font-size: 1.05rem;
`;

const Actions = styled.div`
  margin-top: 28px;
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
`;

const BtnPrimary = styled.a`
  padding: 12px 18px;
  font-weight: 800;
  border-radius: 12px;
  text-decoration: none;
  font-size: 1.05rem;

  background: ${(p) => p.theme.gradients.cta};
  color: ${(p) => p.theme.colors.text};
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
`;

const BtnSecondary = styled.a`
  padding: 12px 18px;
  font-weight: 800;
  border-radius: 12px;
  text-decoration: none;
  font-size: 1.05rem;

  background: rgba(255, 255, 255, 0.18);
  color: ${(p) => p.theme.colors.bgDarker};
  backdrop-filter: blur(6px);
`;

export default function CTA() {
  const [open, setOpen] = useState(false);
  return (
    <Wrapper id="cta">
      <Banner>
        <Title>Want reliable recovery without compliance risk?</Title>

        <Subtitle>
          Partner with <strong>K Shyam G Management</strong> for transparent
          reporting, professional collections, and measurable outcomes.
        </Subtitle>

        <Actions>
          <BtnPrimary href="#contact" onClick={() => setOpen(true)}>
            Contact Us
          </BtnPrimary>
          <BtnSecondary href="mailto:sales@kshyamg.management">
            Email Sales
          </BtnSecondary>
        </Actions>
      </Banner>
      <ContactModal
        open={open}
        onClose={() => setOpen(false)}
        phone="+918510040060"
        email="Ksgm012020@gmail.com"
      />
    </Wrapper>
  );
}
